import { inject, Injectable } from '@angular/core';
import { Api } from '@api/api';
import {
  publicOrganizzazioneControllerGetOneOrganizzazioneBySlug,
  PublicOrganizzazioneControllerGetOneOrganizzazioneBySlug$Params,
} from '@api/functions';
import { defer } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrganizzazioneService {
  private readonly api = inject(Api);

  getOrganizzazione(slug: string) {
    const params: PublicOrganizzazioneControllerGetOneOrganizzazioneBySlug$Params = {
      slug,
    };
    return defer(() =>
      this.api.invoke(publicOrganizzazioneControllerGetOneOrganizzazioneBySlug, params),
    );
  }
}
